import { createContext } from "react";
export const IgnoreMutationContext = createContext(null);
